import { ElementRef, Component, ChangeDetectionStrategy, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { WizBaseView, WizRoot, WizEventManager } from '@wizeoo/akm-component-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ViewData } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';

@Component({
  selector: 'root-view',
  templateUrl: './root.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RootView extends WizBaseView implements OnInit, OnDestroy, AfterViewInit {
  
  constructor(public elementRef: ElementRef) {
    super(elementRef);
  }

  // visible si mode "table"
  public get tableMode():boolean {
    let res: boolean = false;
    if(!!Model.getInstance()?.currentVision) {
      if(!Model.getInstance()?.currentVision?.navigationMode || Model.getInstance()?.currentVision?.navigationMode === ViewData.NAVIGATION_TABLE) 
      {res = true};
    
    }
    return res;
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.wizAddListener();
  }

  ngOnDestroy(): void {
    this.wizRemoveListener();
  }

  wizAfterConstruct(): void {
  }

  

  // cette vue n'est jamais removed, donc pas besoin du wizRemove...
  public wizAddListener() {
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.UPDATE_MODEL, this.updateViewDataModel);
  }

  /**
   * alimentation du flag de changement de modèle dans ViewData sur interception d'un event "UPDATE"
   */
  updateViewDataModel(event: AlkEvent): void {
    ViewData.wizUpdateModel = event.data;
  }

}
